import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import { deleteLoadType } from "../actions";
import { useActionState, useEffect } from "react";

export function CreateButton() {
  return (
    <Link to={"/admin/exercise-load-types/create"} className="contents">
      <Button className="mt-4">
        Create
        <Icon icon={PlusIcon} label="Create Feature" className="ml-1" />
      </Button>
    </Link>
  );
}


export function UpdateButton({ id }: { id: number }) {
  return (
    <Link to={`/admin/exercise-load-types/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteButton({ id }: { id: number }) {
  const navigate = useNavigate();

  const deleteLoadTypeWithId = deleteLoadType.bind(null, id);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this Load Type?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteLoadTypeWithId, {
    success: false,
    message: "",
  });

  useEffect(() => {
    if (state.success) {
      navigate(`/admin/exercise-load-types?reload=${Date.now()}`, { replace: true });
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}
